import { useCallback } from 'react';
import { useTestContext } from '../context/testContext';

export const useResultData = () => {
  const { updateTestData } = useTestContext();

  const clearAllResults = useCallback(() => {
    localStorage.removeItem('videoRecordingData');
    localStorage.removeItem('cornerFixationImages');
    updateTestData({
      leftEye: null,
      rightEye: null,
      bothEyes: null,
      testLeftEye: null,
      testRightEye: null,
      testBothEyes: null,
      testInProgress: null,
      forthValleyVisualFieldDots: [],
      visualFieldForthValley: { results: {} },
      contrastSensitivityResults: [],
      visualFieldTwoResults: [],
    });
  }, [updateTestData]);

  const clearCurrentEyeResults = useCallback(
    (currentEye) => {
      updateTestData({ [currentEye]: null });
    },
    [updateTestData],
  );

  return { clearAllResults, clearCurrentEyeResults };
};
